<template>
  <div ref="deptManagement">
    <div class="form-area" ref="form">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        label-position="left"
        label-width="72px"
      >
        <el-form-item>
          <el-button type="primary" size="small" @click="onAddDept">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-edit-outline"
            type="text"
            size="small"
            sort="primary"
            @click="onUpdateDept(scope.row)"
          >编辑</el-button>
          <el-button
            icon="el-icon-plus"
            type="text"
            size="small"
            sort="authorize"
            @click="onAddChildDept(scope.row)"
          >新增部门</el-button>
          <el-button
            icon="el-icon-delete"
            type="text"
            size="small"
            sort="danger"
            @click="onDeleteDept(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" v-if="dialogVisible" :visible.sync="dialogVisible" width="70%">
      <div>
        <div class="body"></div>
        <addDept
          ref="addDept"
          :title="title"
          :deptId="deptId"
          :parentId="parentId"
          @onDialogClose="onDialogClose"
          :loadData="loadData"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="small" @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="onSave"
        >{{ title.indexOf("新增") !== -1 ? "新增" : "保存"}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { deptTree, deleteDept } from "@/api/lib/api.js";
import addDept from "./components/addDept.vue";
export default {
  name: "deptManagement",
  components: {
    addDept
  },
  data () {
    return {
      tableData: [],
      title: "",
      deptId: null,
      parentId: "0",
      dialogVisible: false,
      form: {}
    };
  },
  methods: {
    //加载企业数据
    loadData () {
      deptTree({}).then(res => {
        if (res.code === 0) {
          this.tableData = res.data;
        } else {
          this.$message.error("获取企业列表失败");
          return [];
        }
      });
    },
    //新增
    onAddDept () {
      this.title = "新增企业";
      this.parentId = 0;
      this.dialogVisible = true;
    },
    //新增子级部门
    onAddChildDept (row) {
      this.title = "新增部门";
      this.parentId = row.id;
      this.dialogVisible = true;
    },
    // 更新企业
    onUpdateDept (row) {
      this.title = "修改企业信息";
      this.deptId = row.id;
      this.dialogVisible = true;
    },
    //保存
    onSave () {
      this.$refs.addDept.onSave();
    },
    // 删除企业
    onDeleteDept (row) {
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        type: "warning",
        message: h("p", null, [
          h("span", null, "确定删除 "),
          h("i", { style: "color: #059370" }, row.name),
          h("span", null, " ？")
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          deleteDept(row.id).then(res => {
            if (res.code === 0) {
              this.$message.success("删除成功");
              this.loadData();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            showClose: true,
            message: "已取消删除"
          });
        });
    },
    // 弹窗关闭时的回调
    onDialogClose () {
      this.dialogVisible = false;
    }
  },
  mounted () {
    this.loadData();
  }
};
</script>